import { unityProviderStore } from '../components/UnityLoader/unity.provider.store';
import { cacheService } from '../services/cacheService';

export const isAdmin = (admins: any = unityProviderStore.roomData?.admins) =>
  !!admins?.filter((user: any) => user.id == cacheService.get('Id'))[0];

export const isCreator = (id: any = unityProviderStore.roomData?.creator?.id) =>
  id == cacheService.get('Id');
